module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ci-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.pipelines), function(model) {
    return _c('pipelines-table-row-component', {
      key: model.id,
      attrs: {
        "pipeline": model,
        "update-graph-dropdown": _vm.updateGraphDropdown
      }
    })
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gl-responsive-table-row table-row-header",
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    staticClass: "table-section section-10 js-pipeline-status pipeline-status",
    attrs: {
      "role": "rowheader"
    }
  }, [_vm._v("\n      Status\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "table-section section-15 js-pipeline-info pipeline-info",
    attrs: {
      "role": "rowheader"
    }
  }, [_vm._v("\n      Pipeline\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "table-section section-25 js-pipeline-commit pipeline-commit",
    attrs: {
      "role": "rowheader"
    }
  }, [_vm._v("\n      Commit\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "table-section section-15 js-pipeline-stages pipeline-stages",
    attrs: {
      "role": "rowheader"
    }
  }, [_vm._v("\n      Stages\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/~/vue-loader/lib/template-compiler?{"id":"data-v-51860a3c"}!/var/cache/omnibus/src/gitlab-rails/~/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_table.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-51860a3c"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_table.vue
// module chunks = commit_pipelines pipelines